@if (bloggerCardHeader()) {
  <div class="header-container">
    <img
      appImgFallback
      class="header-avatar"
      alt="Аватар блогера"
      [src]="bloggerCardHeader()['avatarUrl']"
    />
    <div class="header-text-container">
      <h1 class="header-blogger-name">
        {{ bloggerCardHeader()['username'] }}
      </h1>
      <div class="header-blogger-description">
        @for (item of headerItems; track $index) {
          <span>{{ item.value }}</span>
          @if (item.needBtn) {
            <button
              mat-mini-fab
              type="button"
              color="accent"
              [class]="item.btnClass"
              (click)="updateRating()"
            >
              <mat-icon
                class="gray-filter"
                [class]="item.iconClass"
              >
                {{ item.iconName }}
              </mat-icon>
            </button>
          }
          @if (!item.last) {
            <span> ·</span>
          }
        }
      </div>
      @for (profile of profiles(); track $index) {
        <div class="header-blogger-profiles">
          <p class="header-blogger-url">{{profile['url']}}</p>
        </div>
      }
      <div class="buttons-container">
        <button
          mat-button
          color="primary"
          type="button"
          (click)="handleButtonClick('bloggerContact')"
        >
          Контакты
        </button>
        <button
          mat-button
          color="primary"
          type="button"
          (click)="handleButtonClick('bankDetails')"
        >
          Реквизиты
        </button>
        <button
          mat-button
          color="primary"
          type="button"
          (click)="handleAudienceButtonClick()"
        >
          Аудитория
        </button>
        <a
          mat-button
          color="primary"
          target="_blank"
          [href]="bloggerCardHeader()['yandexDiskLink']"
          [disabled]="!bloggerCardHeader()['yandexDiskLink']"
        >
          Яндекс Диск
        </a>
      </div>
    </div>
    <div class="blogger-header-last">
      @for (select of currentBloggerSelectFormFields; track $index) {
        <div class="blogger-select">
          <mat-form-field
            appearance="outline"
            [style.background-color]="getSelectedDataColor(select.fieldName)"
          >
            <mat-label>{{ select.label }}</mat-label>
            <mat-select
              #matSelect
              [(value)]="bloggerCardHeader()[select.fieldName]"
              (selectionChange)="handleSelectChange({
                event: $event,
                key: select.fieldName,
                matSelect: matSelect
              })"
            >
              <mat-option></mat-option>
              @for (option of getOptions(select.fieldName); track $index) {
                <mat-option
                  [value]="option.id"
                  [style.background-color]="getColorWithOpacity(option.color, 0.35)"
                >
                  {{ option.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="blogger-blacklist">
        <div>
          {{ blacklistText() }}
        </div>
        <button
          mat-icon-button
          class="blogger-blacklist-btn"
          type="button"
          [matTooltip]="blacklistTooltipText()"
          (click)="handelToggleBlacklist()"
        >
          <mat-icon class="blogger-blacklist-btn-icon">
            refresh
          </mat-icon>
        </button>
      </div>
    </div>
    <div class="blogger-actions">
      <app-action-dropdown-menu
        [actionsList]="getActionList()"
        (actionSelected)="handleActionSelect($event)"
      />
    </div>
  </div>
  <!-- Tables  -->
  <app-blogger-profile-tables
    [bloggerDialogData]="bloggerDialogData()"
  />
}
